module.exports = __webpack_public_path__ + "45198371c96579d535e5ba77b4aecc91.png";